export default __webpack_public_path__ + "static/1200-6373a5029f3450832831b1eb876b843c.gif";